import { useMutation } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import { CompanyReportWindow } from "@/types";

export function useDownloadCompanyReport() {
  return useMutation({
    mutationFn: async ({
      companyId,
      companyName,
      window: reportWindow,
    }: {
      companyId: string;
      companyName: string;
      window: CompanyReportWindow;
    }) => {
      const response = await guacHttpClient.get<Blob>(
        `companies/${companyId}/download-report`,
        {
          params: { window: reportWindow },
          responseType: "blob",
        },
      );

      const url = URL.createObjectURL(response.data);
      const anchor = document.createElement("a");
      anchor.href = url;
      anchor.download = `${companyName}-report-${reportWindow}.csv`;
      anchor.click();
      URL.revokeObjectURL(url);
    },
  });
}
